<template>
    <v-group :config="{ ...printAreaConfig }">
        <v-group :config="{ x: printAreaOffsetX }">
            <v-group :config="{ ...clippingMaskConfig, fillPatternImage: null }">
                <artwork-bundled
                    v-if="artworks"
                    :artwork="artworks"
                    :width="artworkWidth"
                    :height="printAreaConfig.height"
                    :parentRatio="ratio"
                    :offset="{
                        x: printAreaConfig.x + printAreaOffsetX,
                        y: printAreaConfig.y,
                        offsetX: printAreaOffsetX
                    }"
                    :rotation="printAreaConfig.rotation"
                    :personalized="personalized"
                />
            </v-group>
        </v-group>
    </v-group>
</template>

<script>
import { get, map, pick, concat } from 'lodash'
import ArtworkBundled from '../ArtworkBundled/ArtworkBundled'
export default {
  components: { ArtworkBundled },
    name: "print-area-bundled",
    props: {
        layer: {
            type: Object
        },
        ratio: {
            type: Number,
            default() {
                return 1
            }
        },
        personalized: {
            type: Object,
            default(){
                return {}
            }
        },
        artworks: {
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            artwork: null,
            printAreaOffsetX: 0
        }
    },
    created(){
    },
    computed: {
        layers() {
            const template = get(this.personalized, `${this.artworks[0].id}.template`, 0)
            return get(this.artworks[0], `templates[${template}].layers`)
        },
        imgProps() {
            const { layer, artworkImg } = this
            const props = { x: 0, y: 0, width: layer.width, height: layer.height }
            const layerRatio = layer.width / layer.height
            if (artworkImg) {
                const imgRatio = artworkImg.width / artworkImg.height
                if (imgRatio < layerRatio) {
                props.width = props.height * imgRatio
                props.x = (layer.width - props.width) / 2
                } else if (imgRatio > layerRatio) {
                props.height = props.width / imgRatio
                }
            }
            return props
        },
        printAreaConfig() {
            const { layer } = this
            var config = pick(layer, [
                'x',
                'y',
                'width',
                'height',
                'scaleX',
                'scaleY',
                'rotation',
                'skewX',
                'skewY'
            ])
            var scaleX = get(config, 'scaleX', 1)
            var scaleY = get(config, 'scaleX', 1)
            config.width = config.width * scaleX
            config.height = config.height * scaleY
            config.scaleX = 1
            config.scaleY = 1
            return config
        },
        clippingMaskConfig(){
            const { layer, printAreaConfig } = this
            const config = { ...(layer.clippingMask || {}) }
            if (
                !layer.clippingMaskEnable ||
                typeof layer.clippingMask === 'undefined'
            ) {
                config.x = 0
                config.y = 0
                config.width = layer.width
                config.height = layer.height
            }
            var scaleX = get(layer, 'scaleX', 1)
            var scaleY = get(layer, 'scaleY', 1)
            return {
                x: 0,
                y: 0,
                width: printAreaConfig.width,
                height: printAreaConfig.height,
                clipFunc: ctx => {
                    ctx.rect(
                        config.x * scaleX - this.printAreaOffsetX,
                        config.y * scaleY,
                        config.width * scaleX,
                        config.height * scaleY
                    )
                }
            } 
        },
        artworkLoading() {
            const { loadings, artworks } = this
            if (artworks) {
                return map(get(loadings, artworks[0].id, {})).some(
                loading => loading === true
                )
            }
            return false
        },
        artworkWidth() {
            const { artworks, printAreaConfig } = this
            var artworkRatio = artworks[0].width / artworks[0].height
            var printAreaRatio = printAreaConfig.width / printAreaConfig.height
            if (artworkRatio >= printAreaRatio) {
                return printAreaConfig.width
            } else {
                this.printAreaOffsetX =
                (printAreaConfig.width - printAreaConfig.height * artworkRatio) / 2
                return printAreaConfig.height * artworkRatio
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/BundledProduct/MockupBundled/PrintAreaBundled.vue